import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaymentMethodRequest } from '../types/payment-iframe-types';
import { PaymentMethodUpdateTokenProviderRequest } from '../types/payment-method-update.model';
import { buildUrl } from '../utility/common.utils';
import { map, Observable } from 'rxjs';
import { AuthModel } from '../models/auth.model';

const CREATE_PAYMENT_METHOD_URL = `${environment.apiUrl}/users/:userId/paymentmethods`;
const UPDATE_PAYMENT_METHOD_URL = `${environment.apiUrl}/users/:userId/paymentmethods`;
const LOGIN_WITH_EXTERNAL_URL = `${environment.apiAuthUrl}/auth/external/login`;

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private http: HttpClient) {}

  createPaymentMethod(
    token: string,
    userId: string,
    paymentMethod: PaymentMethodRequest
  ) {
    const url = buildUrl(CREATE_PAYMENT_METHOD_URL, { userId });

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.post(url, paymentMethod, { headers });
  }

  loginWithExternal(token: string): Observable<AuthModel> {
    return this.http
      .post(LOGIN_WITH_EXTERNAL_URL, {
        token,
      })
      .pipe(
        map((data: any) => {
          const authModel = new AuthModel();
          authModel.setAuth(data);
          return authModel;
        })
      );
  }

  updatePaymentMethod(
    token: string,
    userId: string,
    paymentMethodUpdate: PaymentMethodUpdateTokenProviderRequest
  ) {
    const url = buildUrl(UPDATE_PAYMENT_METHOD_URL, { userId });

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.put(url, paymentMethodUpdate, { headers });
  }
}
